import { render, staticRenderFns } from "./Remitos-de-venta.vue?vue&type=template&id=40183364"
import script from "./Remitos-de-venta.vue?vue&type=script&lang=js"
export * from "./Remitos-de-venta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports